// extracted by mini-css-extract-plugin
export default {"tr":"MergeList_tr__r+3Fv","sticky":"MergeList_sticky__Gta2L","buttonsWrapper":"MergeList_buttonsWrapper__lqyJ-","submitRemoveButton":"MergeList_submitRemoveButton__niszm"};